module.exports = __webpack_public_path__ + "img/max-file-subtract--json.90f96097.svg";